import React from 'react';
import { motion } from 'framer-motion';
import Header from '../components/Header';

const Specifications = () => {
  return (
    <motion.div 
      className="min-h-screen bg-arch-light dark:bg-dark-bg text-arch-dark dark:text-gray-200 transition-colors duration-300"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <Header />

      <div className="pt-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <header className="mb-20 border-b border-arch-border dark:border-dark-border pb-10">
            <h1 className="text-4xl font-bold tracking-tight mb-4 text-arch-dark dark:text-white">Technický katalog a specifikace</h1>
            <p className="text-accent-teal font-mono text-sm">Dokumentace produktu: WPC Interiérové panely (BJX001)</p>
          </header>

          {/* Sekce 1 */}
          <section className="mb-16">
            <h2 className="text-xs font-bold text-brand-500 uppercase tracking-widest mb-6 border-b border-arch-border dark:border-dark-border pb-2">01 / Charakteristika produktu</h2>
            <div className="bg-white dark:bg-dark-surface border border-arch-border dark:border-dark-border p-8">
              <p className="text-sm text-arch-gray dark:text-gray-400 leading-relaxed">
                WPC panely jsou syntetické obkladové desky určené pro interiérové použití, zejména pro obklady stěn, stropů, dveří a nábytkových čel.
                Spojují vlastnosti plastu a dřeva, umožňují přesné opracování a nabízejí stabilní mechanické i hygienické parametry vhodné pro komerční i rezidenční projekty s nejvyššími nároky na design.
              </p>
            </div>
          </section>

          {/* Sekce 2 */}
          <section className="mb-16">
            <h2 className="text-xs font-bold text-accent-teal uppercase tracking-widest mb-6 border-b border-arch-border dark:border-dark-border pb-2">02 / Složení a materiály</h2>
            <div className="bg-white dark:bg-dark-surface border border-arch-border dark:border-dark-border p-0 grid md:grid-cols-2">
              <div className="p-8 border-b md:border-b-0 md:border-r border-arch-border dark:border-dark-border">
                <h3 className="text-sm font-bold text-arch-dark dark:text-white uppercase tracking-wider mb-4">Výrobní proces</h3>
                <p className="text-sm text-arch-gray dark:text-gray-400">Extruzní formování kompozitu s koextrudovanou krystalickou vrstvou.</p>
              </div>
              <div className="p-8">
                <h3 className="text-sm font-bold text-arch-dark dark:text-white uppercase tracking-wider mb-4">Materiálové složení</h3>
                <ul className="text-sm text-arch-gray dark:text-gray-400 space-y-2 font-mono">
                  <li><span className="text-accent-teal mr-2">/</span> PVC masterbatch: ~85%</li>
                  <li><span className="text-accent-teal mr-2">/</span> Pryskyřice (resin): ~7%</li>
                  <li><span className="text-accent-teal mr-2">/</span> Vápníkový prášek: ~5%</li>
                  <li><span className="text-accent-teal mr-2">/</span> Bambusové vlákno: ~3%</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Sekce 3 */}
          <section className="mb-16">
            <h2 className="text-xs font-bold text-accent-sage uppercase tracking-widest mb-6 border-b border-arch-border dark:border-dark-border pb-2">03 / Rozměry a formáty</h2>
            <div className="bg-white dark:bg-dark-surface border border-arch-border dark:border-dark-border p-8">
              <div className="grid md:grid-cols-2 gap-12">
                <div>
                  <h3 className="text-sm font-bold text-arch-dark dark:text-white uppercase tracking-wider mb-6">Standardní panely</h3>
                  <div className="space-y-4 text-sm font-mono border-l-2 border-accent-sage pl-4">
                    <div><span className="text-arch-gray dark:text-gray-500">Rozměr:</span> <span className="dark:text-white">1100 × 2800 mm</span></div>
                    <div><span className="text-arch-gray dark:text-gray-500">Běžné tloušťky:</span> <span className="dark:text-white">5, 8 mm</span></div>
                    <div><span className="text-arch-gray dark:text-gray-500">Dostupné tl.:</span> <span className="dark:text-white">5, 8, 12, 15, 18 mm</span></div>
                  </div>
                </div>
                <div>
                  <h3 className="text-sm font-bold text-arch-dark dark:text-white uppercase tracking-wider mb-6">Rýhované provedení</h3>
                  <div className="space-y-4 text-sm font-mono border-l-2 border-arch-border dark:border-dark-border pl-4">
                    <div><span className="text-arch-gray dark:text-gray-500">Délka:</span> <span className="dark:text-white">3000 mm</span></div>
                    <div className="text-arch-gray dark:text-gray-500 mt-2">Příklady profilů:</div>
                    <ul className="space-y-1 dark:text-gray-300">
                      <li>170 × 3000 mm (tl. 23,5 mm)</li>
                      <li>100 × 3000 mm (tl. 19,5 mm)</li>
                      <li>110 × 3000 mm (tl. 18 mm)</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Sekce 4 */}
          <section className="mb-16">
            <h2 className="text-xs font-bold text-accent-clay uppercase tracking-widest mb-6 border-b border-arch-border dark:border-dark-border pb-2">04 / Aplikace a využití</h2>
            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-white dark:bg-dark-surface border border-arch-border dark:border-dark-border p-8">
                <h3 className="text-sm font-bold text-arch-dark dark:text-white uppercase tracking-wider mb-4">Vhodné použití</h3>
                <ul className="text-sm text-arch-gray dark:text-gray-400 space-y-2">
                  <li><span className="text-brand-500 mr-2">/</span> Obklady stěn a stropů</li>
                  <li><span className="text-brand-500 mr-2">/</span> Obklady dveří</li>
                  <li><span className="text-brand-500 mr-2">/</span> Nábytková čela</li>
                  <li><span className="text-brand-500 mr-2">/</span> Dekorativní architektonické prvky</li>
                </ul>
              </div>
              <div className="bg-arch-light dark:bg-[#1A1D24] border border-arch-border dark:border-dark-border p-8">
                <h3 className="text-sm font-bold text-arch-dark dark:text-white uppercase tracking-wider mb-4">Omezení (Nevhodné)</h3>
                <ul className="text-sm text-arch-gray dark:text-gray-400 space-y-2">
                  <li><span className="text-accent-clay mr-2">/</span> Nášlapné podlahy</li>
                  <li><span className="text-accent-clay mr-2">/</span> Interiér sprchových koutů</li>
                  <li><span className="text-accent-clay mr-2">/</span> Zázemí varných desek</li>
                  <li><span className="text-accent-clay mr-2">/</span> Zátěžové pracovní desky</li>
                </ul>
              </div>
            </div>
          </section>
        </div>
      </div>
    </motion.div>
  );
};

export default Specifications;